import React, { useEffect } from "react";
import { Typography } from "antd";
import Loading from "../../components/loading";

const { Paragraph } = Typography;

const CaDISupplyChain = () => {
  useEffect(() => {
    // Create and append the Knack script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://loader.knack.com/64b841fbebd4370028a6cf26/dist_5/knack.js";
    script.async = true;
    document.body.appendChild(script);

    // Set global variables for Knack
    window.app_id = "64b841fbebd4370028a6cf26";
    window.distribution_key = "dist_5";

    return () => {
      // Clean up script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <Paragraph style={{ marginBottom: 20 }}>
        CaDI Supply Chain allows you to request calculated emissions data from your supply chain partners.
      </Paragraph>

      <div id="knack-dist_5">
        <Loading  title="Loading CaDI Supply Chain. Please wait a while..."/>

      </div>
    </div>
  );
};

export default CaDISupplyChain; 
